"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchField = exports.BaseSwitchField = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var Text_1 = require("./Text");
var UIComponents_1 = require("./UIComponents");
var SwitchLabel = function (props) { return (react_1.default.createElement(FlexRow, null,
    react_1.default.createElement(StyledLabel, null,
        react_1.default.createElement(VerticallyCenteredRow, null,
            props.children,
            react_1.default.createElement(Text_1.Text, { variant: "paragraphMedium", ml: "8px", opacity: props.disabled ? "0.3" : "1" }, props.label))))); };
var FlexRow = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledLabel = styled_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var VerticallyCenteredRow = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var SwitchInput = function (_a) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    var handleChange = function (event) {
        event.stopPropagation();
        onChange(event.target.checked);
    };
    return (react_1.default.createElement(RelativeDiv, null,
        react_1.default.createElement(StyledInput, __assign({}, props, { type: "checkbox", checked: props.isSelected, onClick: handleChange })),
        react_1.default.createElement(DummyInput, __assign({}, props))));
};
var RelativeDiv = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var DummyInput = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-radius: 70px;\n    transition: 0.1s;\n    width: 32px;\n    height: 20px;\n    position: relative;\n    opacity: ", ";\n    background: ", ";\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 2px;\n        border-radius: 70px;\n        width: 16px;\n        height: 16px;\n        background: white;\n        transition: 0.2s linear;\n        left: ", ";\n"], ["\n    border-radius: 70px;\n    transition: 0.1s;\n    width: 32px;\n    height: 20px;\n    position: relative;\n    opacity: ", ";\n    background: ", ";\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 2px;\n        border-radius: 70px;\n        width: 16px;\n        height: 16px;\n        background: white;\n        transition: 0.2s linear;\n        left: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.3 : 1);
}, function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected;
    return isSelected ? theme.colors.primary : theme.colors.gray300;
}, function (_a) {
    var isSelected = _a.isSelected;
    return (isSelected ? "14px" : "2px");
});
var StyledInput = styled_1.default.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  z-index: 1;\n  width: 32px;\n  height: 20px;\n  border-radius: 70px;\n  cursor: ", ";\n"], ["\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  z-index: 1;\n  width: 32px;\n  height: 20px;\n  border-radius: 70px;\n  cursor: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "not-allowed" : "pointer");
});
var BaseSwitchField = function (_a) {
    var onChange = _a.onChange, className = _a.className, props = __rest(_a, ["onChange", "className"]);
    return (react_1.default.createElement(UIComponents_1.ui.Wrapper, __assign({ className: className }, props),
        react_1.default.createElement(SwitchLabel, __assign({}, props),
            react_1.default.createElement(SwitchInput, __assign({ onChange: onChange }, props)))));
};
exports.BaseSwitchField = BaseSwitchField;
var SwitchField = function (props) {
    var _a = (0, formik_1.useField)(props.name), field = _a[0], helpers = _a[2];
    return (react_1.default.createElement(exports.BaseSwitchField, __assign({}, props, { isSelected: field.value, onChange: helpers.setValue })));
};
exports.SwitchField = SwitchField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
